import { render, staticRenderFns } from "./ParticipantsDialog.vue?vue&type=template&id=06e938ef"
import script from "./ParticipantsDialog.vue?vue&type=script&lang=js"
export * from "./ParticipantsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports